import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { of } from 'rxjs';
import { map, take, timeout, switchMap, catchError } from 'rxjs/operators';

export const advisorGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // resolvedUser$ waits for Firebase to restore the session (BUG-6).
  return authService.resolvedUser$.pipe(
    take(1),
    timeout(10000),
    switchMap(user => {
      if (!user) {
        router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
        return of(false);
      }
      return authService.customClaims$.pipe(
        take(1),
        timeout(5000),
        map(claims => {
          const isAdvisor = claims?.roles?.includes('advisor') ?? false;
          const isAdmin = claims?.roles?.includes('admin') ?? false;
          if (isAdvisor || isAdmin) {
            return true;
          }
          router.navigate(['/'], {
            queryParams: {
              accessDenied: 'true',
              message: 'You need advisor access to request terms.'
            }
          });
          return false;
        })
      );
    }),
    catchError(error => {
      console.error('Advisor guard: Error checking access:', error);
      router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
      return of(false);
    })
  );
};
